import type { FunctionComponent } from 'react';
import Question from '../../../interfaces/question';
import breakpoints from '../../../utils/breakpoints';
import useCurrentWidth from '../../commons/use-current-width/useCurrentWidth';
import SubQuestion from './SubQuestion';
import * as styles from './Multiple.module.css';

export interface MultipleProps {
  questions: Question[];
}

const Multiple: FunctionComponent<MultipleProps> = ({ questions }) => {
  const [firstQuestion] = questions;
  const groupingLabels = firstQuestion.radioButtonOptions.map((r) => r.description);
  const groupingLabelsArePresent = groupingLabels.length !== 0;
  const currentWidth = useCurrentWidth();
  const isDesktop = currentWidth >= breakpoints.medium;
  const displayGroupingLabels = groupingLabelsArePresent && isDesktop;

  return (
    <div>
      {displayGroupingLabels && (
        <div className={styles.headerContainer}>
          <div className={styles.emptyLabel} />
          <div className={styles.groupingLabels}>
            {groupingLabels.map((description) => (
              <div className={styles.groupingLabel} key={description?.split(' ').join('-')}>
                <span>{description}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {questions.map((q) => (
        <SubQuestion question={q} key={`subQuestion-${q.id}`} />
      ))}
    </div>
  );
};

export default Multiple;
